'use client'

import { Typo3FacetAttributesContent } from '@/types'
import { Checkbox as CheckboxInput } from '@/ui/components'
import { memo, useEffect, useEffectEvent, useState } from 'react'

interface Props extends React.HTMLAttributes<HTMLDivElement> {
  children?: React.ReactNode
  onClick?: () => void
  data: Typo3FacetAttributesContent
  id: string
  isDropdown?: boolean

  store: any
}

const SpotSanityCheckbox = ({
  children,
  onClick,
  data,
  isDropdown,
  store,
  id
}: Props) => {
  const [isActive, setIsActive] = useState<boolean>(false)
  const { facets, setFacets, setDropdownFacets, dropdownFacets } = store()

  const onFacetUpdate = useEffectEvent((isActiveInStore: boolean) => {
    setIsActive(isActiveInStore)
  })

  // Effect to sync isActive with the facets store
  useEffect(() => {
    const isActiveInStore = facets.includes(data.facetKeyTypo3)
    onFacetUpdate(isActiveInStore)
  }, [facets, data.facetKeyTypo3])

  // Handlers
  const handleClick = () => {
    const newIsActive = !isActive
    setIsActive(newIsActive)

    if (newIsActive) {
      setFacets([...facets, data.facetKeyTypo3])
      if (isDropdown) {
        setDropdownFacets([...dropdownFacets, data.title])
      }
    } else {
      setFacets(facets.filter((item: string) => item !== data.facetKeyTypo3))
      if (isDropdown) {
        setDropdownFacets(
          dropdownFacets.filter((item: string) => item !== data.title)
        )
      }
    }

    onClick && onClick()
  }

  const labelId = `${String(children)}-label`
  const checkboxId = id || labelId

  return (
    <CheckboxInput
      label={String(children)}
      id={checkboxId}
      checked={isActive}
      onClick={handleClick}
    />
  )
}

SpotSanityCheckbox.displayName = 'SpotSanityCheckbox'

export default memo(SpotSanityCheckbox)
